import RestApiCall from "interceptor/aeh";
import Environment from "services/environment";

const env = Environment.getEnv();

export const fetchRbacToken = (payload) => {
    let apiPayload = {
        method: "GET",
        url: "/user/profile/rbacToken/v1",
        baseURL: env.profileBaseUrl,
        params: payload,
    };
    return RestApiCall.api(apiPayload);
};
